import React, { useEffect, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { getUserProfile } from '../services/userService';

const Navigation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { currentUser } = useAuth();
  const [isSeller, setIsSeller] = useState(false);

  useEffect(() => {
    const checkSeller = async () => {
      if (currentUser) {
        try {
          const profile = await getUserProfile(currentUser.uid);
          setIsSeller(profile?.role === 'seller');
        } catch {
          setIsSeller(false);
        }
      } else {
        setIsSeller(false);
      }
    };
    checkSeller();
  }, [currentUser]);

  return (
    <div className="fixed-bottom d-flex justify-content-center pb-3">
      <Navbar 
        className="bg-dark shadow-lg rounded-pill px-4 mx-auto" 
        style={{ 
          backgroundColor: '#12121B', 
          width: '410px', 
          height: '70px',
          maxWidth: '95%' 
        }}
      >
        <Nav className="w-100 d-flex justify-content-between">
          <Nav.Link
            as={Link}
            to="/"
            className={`text-center ${location.pathname === '/' ? 'text-white' : 'text-secondary'}`}
          >
            <i className="bi bi-house fs-4 d-block mb-0"></i>
            <span className="small">Home</span>
          </Nav.Link>
          
          <Nav.Link
            as={Link}
            to="/shops"
            className={`text-center ${location.pathname === '/shops' ? 'text-white' : 'text-secondary'}`}
          >
            <i className="bi bi-shop fs-4 d-block mb-0"></i>
            <span className="small">Negozi</span>
          </Nav.Link>
          
          <Nav.Link
            as={Link}
            to="/checkout"
            className={`text-center ${location.pathname === '/checkout' ? 'text-white' : 'text-secondary'}`}
          >
            <i className="bi bi-cart fs-4 d-block mb-0"></i>
            <span className="small">Carrello</span>
          </Nav.Link>

          {isSeller && (
            <Nav.Link
              as={Link}
              to="/seller"
              className={`text-center ${location.pathname === '/seller' ? 'text-white' : 'text-secondary'}`}
            >
              <i className="bi bi-shop-window fs-4 d-block mb-0"></i>
              <span className="small">Venditore</span>
            </Nav.Link>
          )}
          
          <Nav.Link
            as={Link}
            to="/profile"
            className={`text-center ${location.pathname === '/profile' ? 'text-white' : 'text-secondary'}`}
          >
            <i className="bi bi-person fs-4 d-block mb-0"></i>
            <span className="small">Profilo</span>
          </Nav.Link>
        </Nav>
      </Navbar>
    </div>
  );
};

export default Navigation; 